/**
 * RTWO Native Currency Engine — Base Service
 */

import { NATV_ENGINE_VERSION } from '../domain-models';
import type { INATVService, NATVServiceDescriptor, NATVServiceStatus } from '../service-interfaces';
import type { natvInternalEventBus } from '../events/natv-event-bus';

export interface NATVServiceContext {
  eventBus: typeof natvInternalEventBus;
}

export abstract class BaseNATVService implements INATVService {
  abstract readonly serviceId: string;
  abstract readonly serviceName: string;
  abstract readonly description: string;
  abstract readonly integrations: string[];
  abstract readonly requiresGenesisConfiguration: boolean;
  abstract readonly requiresLedgerConnection: boolean;
  readonly version = NATV_ENGINE_VERSION.version;

  protected status: NATVServiceStatus = 'not_initialized';

  constructor(protected readonly context: NATVServiceContext) {}

  async initialize(): Promise<void> {
    this.status = 'waiting_for_genesis_configuration';
  }

  getStatus(): NATVServiceStatus {
    return this.status;
  }

  getDescriptor(): NATVServiceDescriptor {
    return {
      serviceId: this.serviceId,
      serviceName: this.serviceName,
      version: this.version,
      status: this.status,
      description: this.description,
      integrations: this.integrations,
      requiresGenesisConfiguration: this.requiresGenesisConfiguration,
      requiresLedgerConnection: this.requiresLedgerConnection,
    };
  }
}
